import React from 'react';
import ContactFold from '../component/contact/ContactFold';
import ContactFixed from '../component/contact/ContactFixed';
import { useShortCut } from '../shared/hooks/useShortCut';
import ArchivePageFrame from '../shared/component/ArchivePageFrame';
import { useNavLayout } from '../shared/hooks/useNavLayout';
import { NavLayout } from '../shared/enum/EnumRepository';


const Contact: React.FC = () => {
  const { handleCmdE } = useShortCut();
  const navLayout = useNavLayout();

  return (
    <ArchivePageFrame
      onKeyDown={(e) => handleCmdE(e)}
      tabIndex={-1}
    >
      {navLayout === NavLayout.FIXED ? <ContactFixed /> : <ContactFold />}
    </ArchivePageFrame>
  );
}

export default Contact;
